import { useWSSnackbar } from "@wingspanhq/fe-component-library";
import { queriesInvoices } from "@query";

export const useAcceptInvoice = () => {
  const { openSnackbar } = useWSSnackbar();
  return queriesInvoices.acceptInvoice.useMutation({
    onSuccess: () => {
      openSnackbar({ type: "success", message: "Invoice accepted" });
    },
    onError: () => {
      openSnackbar({ type: "warning", message: "Failed to accept invoice" });
    }
  });
};
